<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="c03">
<div class="chbrd">
<h1 class="chapter_date"><a id="page16"></a><strong>c. 550 BCE</strong></h1>
<h1 class="chapter_title">The Dao</h1>
<p class="bauthorb"><strong>Laozi</strong> (fl. c. 550 BCE)</p>
</div>
<p class="nonindent">Chinese civilization has been shaped by three major traditions: Confucianism, Buddhism, and Daoism. The oldest of these may be Daoism, but it is difficult to say because the origins of Daoism are shrouded in mystery and legend.</p>
<p class="indent">According to Chinese tradition, Daoism was founded by the sage Laozi around 550 BCE. Laozi is the reputed author of the classic Daoist text the <em>Dao De Jing</em> (<em>Classic of the Way and Power</em>), a short book full of memorable aphorisms and profound sayings, but not easy to understand. There is a point to this ambiguity, however, for Daoists believe that life itself is inherently mysterious. Ultimate Reality, they claim, cannot be grasped by words or concepts; it can only be felt in the pulse in moments of tranquility.</p>
<p class="indent">The central concept of Daoism is that of the <em>Dao</em> (“the Way”). The Dao means, at once, the way of ultimate Reality, the way of the universe, and the way that humans should order their lives. It is the ineffable and transcendent ground of all existence, yet it is also immanent; it orders and flows through all things. To live well is to live in harmony with the Dao, and this means to live simply, naturally, and contentedly in a way attuned to the rhythms and harmonies of nature.</p>
<p class="indent">In many ways, Daoism is the direct opposite of Confucianism, which is the most influential tradition of Chinese wisdom. The strong emphasis Confucianists place on book learning, active government, and elaborate ritual are all rejected by Daoists. They favor a natural, spontaneous approach to life. This idea is captured in the Daoist concept of <em>wu wei,</em> or “effortless doing.” Wu wei literally means “inaction” or “non-doing,” but it is not a recipe for do-nothing passivity. Rather, it is a counsel for letting things happen naturally and without meddlesome interference or unnecessary conflict. Daoists believe that people often mess things up when they try to “fix things” by passing too many laws or by trying to micromanage people’s lives. In most cases, they claim, more can be accomplished by means of a less activist, more yielding approach.</p>
<p class="captionl" id="img17"><em>A monumental statue of revered Daoism founder Laozi at Mount Qingyuan in the city of Quanzhou, on the coast of southeast China.</em></p>
<div class="dis_imgb"><a id="page17"></a><img alt="" src="OEBPS/images/17-1.jpg"/></div>
<div class="xref">
<p class="seal"><span class="sls"><strong>SEE ALSO</strong></span> <a class="hlink" href="#/OEBPS/9781454935575_c09">Confucian Ethics (c. 500 BCE)</a>, <span class="hlink" href="#/OEBPS/9781454935575_c23" title="Link target outside of Sample">Cynicism (c. 400 BCE)</span></p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454935575_c03.vue?525fc0b4